export default "__VITE_ASSET__jteSsyqd__"